import React from 'react';
import { Alert, Row, Col } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import { FrontLayout } from '../layout/FrontLayout';
import { AdminLayout } from '../layout/AdminLayout';
import './AlertPage.scss';

export interface AlertPageProps extends AlertProps {
  isAdmin?: boolean;
}

/**
 * Pagina che contiene un solo messaggio di avviso.
 */
export function AlertPage(props: AlertPageProps) {
  const { isAdmin, ...otherProps } = props;
  if (isAdmin)
    return (
      <AdminLayout>
        <div className="alert-page-admin">
          <Alert {...otherProps} />
        </div>
      </AdminLayout>
    );

  return (
    <FrontLayout>
      <Alert {...otherProps} />
    </FrontLayout>
  );
}
